export const buildCashReceiptCarouselItems = (legs = []) => {
  const items = [];

  legs.forEach((leg) => {
    const orderNumber = leg.customer_order_number || "";
    const legLabel = leg.type_of_loc || leg.type_of_order || "LEG";

    (leg.pictures || []).forEach((pic) => {
      const src = pic?.picture?.url;
      if (!src) return;

      items.push({
        src,
        name: orderNumber ? `#${orderNumber} · ${legLabel}` : legLabel,
        pic_code: pic.pic_code || "CASH RECEIPT",
        pic_title: pic.pic_title || "CASH RECEIPT",
        amount: pic.amount,
        image_type: pic.image_type,
        ack_id: pic.ack_id,
        pictures_id: pic._id,
      });
    });
  });

  return items;
};

export const cashReceiptLegsForOrder = (cashReceiptPictures = [], orderId) => {
  if (!orderId) return cashReceiptPictures || [];

  return (cashReceiptPictures || []).filter(
    (leg) => leg.customer_order_id === orderId
  );
};
